import { createPortal } from "react-dom";
import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import { RefreshCw } from "lucide-react";
import { APP_START } from "@/lib/queryCache";

// Visible only while saved (last-known) numbers are on screen and fresh ones are loading.
export function UpdatingTag() {
    const qc = useQueryClient();
    const fetching = useIsFetching();
    const showingSaved = fetching > 0 && qc.getQueryCache().findAll({ fetchStatus: "fetching" })
        .some((q) => q.state.dataUpdatedAt && q.state.dataUpdatedAt < APP_START);
    if (!showingSaved) return null;
    const pill = "items-center gap-1.5 rounded-full border border-primary/30 px-2.5 py-1 text-[11px] font-medium text-primary whitespace-nowrap";
    return (
        <>
            <span className={`hidden sm:inline-flex bg-primary/5 ${pill}`} title="Showing your last-known numbers while fresh prices load" data-testid="updating-prices-tag">
                <RefreshCw className="w-3 h-3 animate-spin" />Updating prices…
            </span>
            {/* phones: header is full, so float above the bottom nav; portal because the blurred header traps "fixed" */}
            {createPortal(
                <span className={`sm:hidden inline-flex fixed left-1/2 -translate-x-1/2 bottom-[calc(76px+env(safe-area-inset-bottom))] z-40 bg-background/95 shadow-md backdrop-blur ${pill}`} data-testid="updating-prices-tag-mobile">
                    <RefreshCw className="w-3 h-3 animate-spin" />Updating prices…
                </span>,
                document.body,
            )}
        </>
    );
}
